import { Input, VDBText } from "@components/atoms";
import Spacer from "@components/atoms/Spacer";
import { SpaceType } from "@components/atoms/Spacer/types";
import { useTypographyStore } from "@redux/slices/typographySlice";
import React, { useEffect, useState } from "react";
import { Controller, useFormState } from "react-hook-form";
import { useTranslation } from "react-i18next";
import styled from "styled-components/native";
import { useTheme } from "styled-components/native";
import { ShareOptionsProps } from "../types";
import { Keyboard } from "react-native";

const ShareOptions = ({ selectedOption, control }: ShareOptionsProps) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const typography = useTypographyStore();
  const [inputError, setInputError] = useState(false);
  const { errors, isValid } = useFormState({
    control,
    name: ["email", "comments"],
  });

  useEffect(() => {
    if (errors?.email?.message) {
      setInputError(true);
    } else {
      setInputError(false);
    }
  }, [errors?.email?.message]);

  return (
    <Overlay>
      {selectedOption === "email" && (
        <InputContainer>
          <Controller
            control={control}
            render={({ field: { onChange, onBlur, value } }) => {
              return (
                <Input
                  inputLabel={t("shareScreen.input.email.placeholder.text")}
                  leftIcon={undefined}
                  hideIconContainer={true}
                  placeholder={t("shareScreen.input.email.placeholder.text")}
                  onBlur={onBlur}
                  onChangeText={onChange}
                  value={value}
                  error={
                    isValid ? "" : ((errors?.email?.message ?? "") as string)
                  }
                />
              );
            }}
            name="email"
          />
          {!inputError && (
            <>
              <Spacer size={SpaceType.Basic} />
              <VDBText type={typography["Minor-R"]} color={theme["core-06"]}>
                {t("shareScreen.input.inlineText.text")}
              </VDBText>
            </>
          )}
          <Spacer size={SpaceType.Double} />
          <Controller
            control={control}
            render={({ field: { onChange, onBlur, value } }) => (
              <Input
                inputLabel={t("shareScreen.input.placeholder.comments.text")}
                placeholder={t("shareScreen.input.placeholder.comments.text")}
                leftIcon={undefined}
                hideIconContainer={true}
                onBlur={onBlur}
                onChangeText={onChange}
                value={value}
                error={(errors?.comments?.message ?? "") as string}
                multiline={true}
                blurOnSubmit={true}
                onSubmitEditing={() => {
                  Keyboard.dismiss();
                }}
                keyboardType="default"
                returnKeyType="done"
              />
            )}
            name="comments"
          />
        </InputContainer>
      )}
    </Overlay>
  );
};

const Overlay = styled.View`
  border-radius: 8px;
  background-color: ${({ theme }) => theme["core-01"]};
  padding: ${SpaceType.Double}px;
`;

const InputContainer = styled.View``;

export default React.memo(ShareOptions);
